import { cn } from '../../helpers';

const selecItemBase = cn(
  'relative flex w-full cursor-pointer select-none items-center rounded-lg px-4 py-2.5 text-base font-medium outline-none '
);

const trigger = (hasError?: boolean, className?: string) =>
  cn(
    'group flex h-[3rem] w-full items-center justify-between rounded-xl bg-white px-4 py-3.5 text-sm font-medium text-black outline-none ring-1 ring-[#E2DFE2] transition-all',
    'hover:ring-offset-2 hover:ring-4 hover:ring-neutral-100 hover:ring-offset-neutral-300',
    'focus-within:ring-2 focus-within:ring-blurple-400',
    'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-neutral-50 disabled:text-base disabled:hover:ring-1 disabled:hover:ring-[#E2DFE2] disabled:hover:ring-offset-0',
    'data-[placeholder]:text-neutral-600 data-[state=open]:outline-none data-[state=open]:ring-4 data-[state=open]:ring-blurple-100 data-[state=open]:ring-offset-2 data-[state=open]:ring-offset-blurple-500',
    hasError ? 'ring-red-500 focus-within:ring-red-500' : null,
    className
  );

const triggerIcon = (hasError?: boolean) =>
  cn(
    'h-6 w-6 text-neutral-600 group-data-[state=open]:rotate-180',
    hasError ? 'text-red-300 group-data-[state=open]:text-neutral-600' : null
  );

const content = (position?: string, className?: string) =>
  cn(
    'relative z-50 min-w-[8rem] overflow-hidden rounded-xl border-2 border-[#E2DFE2] bg-white shadow-sm',
    'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
    position === 'popper'
      ? 'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1'
      : null,
    className
  );

const viewport = (position?: string) =>
  cn(
    'flex flex-col gap-[0.25rem] p-2 overflow-auto',
    position === 'popper'
      ? 'h-[var(--radix-select-trigger-height)] max-h-[11.5rem] w-full min-w-[var(--radix-select-trigger-width)]'
      : null
  );

const item = (className?: string) =>
  cn(
    selecItemBase,
    'hover:bg-blurple-50 focus:bg-blurple-50',
    'data-[disabled]:pointer-events-none data-[state=checked]:bg-blurple-100 data-[state=checked]:text-blurple-500 data-[disabled]:opacity-50',
    className
  );

const indicatorWrapper = cn('ml-auto flex items-center justify-center');
const indicatorIcon = cn('h-5 w-5');

export { content, indicatorIcon, indicatorWrapper, item, selecItemBase, trigger, triggerIcon, viewport };
